import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import { message } from "antd";
import { termination_table } from "../../core/data/json/termination_table";
import { all_routes } from "../router/all_routes";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import {getEmployees,getEmployeeById} from "../../core/data/redux/employee/employeeAction";
import Enum from "../../core/common/Enum/enum";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DeleteModal1 from "../../core/modals/deleteModal1";

import {
  createTermination,
  fetchAllTermination,
  Updatetermination,
  fetchTerminationById,
  deletetermination,
} from "../../core/data/redux/termination/terminationAction";
import { formatDate } from "../../core/utils/configFormatters";
import { Button, Drawer } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { useAppConfig } from "../../customhooks/useAppConfig";
import { decryptData } from "../../core/utils/encryptUtils";

const Termination = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const { user } = useSelector((state: any) => state.auth);
  const terminationId = selectedRowData?.ID;
  const [tableKey, setTableKey] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");

  const { termination, loadingStates } = useSelector((state: any) => state.termination);
  const isLoading = isEditing ? loadingStates.update : loadingStates.create;
  const { employees } = useSelector((state: any) => state.employee);
  const [terminationtype, setterminationtype] = useState<any>([]);
  const [formData, setFormData] = useState<any>({
    employee: "",
    terminationType: "",
    noticeDate: "",
    reason: "",
    resignationDate: "",
    createdBy: user.UserId,
  });
  const formattedTerminationTypes = Object.entries(terminationtype).map(
    ([key, value]) => ({
      value: key,
      label: value,
    })
  );

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");

  const handleDeletePolicy = (terminationId: any) => {
    const TerminationId = terminationId;
    dispatch(deletetermination(TerminationId))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
          window.location.reload();
        } else {
          setIsDeleteModalVisible(false);
          message.warning(resp.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const handleEditPolicy = (record: any): void => {
    setIsEditing(true);
    setSelectedRowData(record);
    setFormData({
      employee: parseInt(record.Employee || ""),
      terminationType: record.Termination_Type || "",
      noticeDate: record.Notice_Date ? record.Notice_Date.split("T")[0] : "",
      reason: record.Reason || "",
      resignationDate: record.Resignation_Date
        ? record.Resignation_Date.split("T")[0]
        : "",
      modifiedBy: user.UserId,
    });
  };

  const handleSelectChange = (selectedOption: any, fieldName: string) => {
    if (fieldName === "employee") {
      setFormData((prev: any) => ({
        ...prev,
        employee: selectedOption.value,
        employeeName: selectedOption.label,
      }));
    } else {
      setFormData((prev: any) => ({
        ...prev,
        [fieldName]: selectedOption?.value || null,
      }));
    }
  };

  const handleDateChange = (date: Date | null, fieldName: string) => {
    setFormData((prev: any) => ({
      ...prev,
      [fieldName]: date ? date.toISOString().split("T")[0] : null,
    }));
  };

  const handleInputChange = (e: any) => {
    setFormData((prev: any) => ({
      ...prev,
      reason: e.target.value,
    }));
  };

  const validateForm = () => {
    if (!formData.employee) {
      message.error("Please select an employee");
      return false;
    }
    if (!formData.terminationType) {
      message.error("Please select a termination type");
      return false;
    }
    if (!formData.noticeDate) {
      message.error("Please select a notice date");
      return false;
    }
    if (!formData.reason || formData.reason.trim() === "") {
      message.error("Please enter a reason");
      return false;
    }
    if (!formData.resignationDate) {
      message.error("Please select a termination date");
      return false;
    }
    if (formData.resignationDate > formData.noticeDate) {
      message.error("termination date cannot be after the notice date.");
      return false;
    }
    return true;
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (!validateForm()) return;

    if (isEditing) {
      dispatch(Updatetermination({ terminationId, data: formData })).then(
        (res) => {
          if (res.meta.requestStatus === "fulfilled") {
            message.success("Updated Successfully");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }
      );
    } else {
      dispatch(createTermination(formData)).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          setFormData({
            employee: null,
            terminationType: null,
            noticeDate: null,
            reason: "",
            resignationDate: null,
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          message.warning(res.payload.message);
        }
      });
    }
  };

  const formattedEmployees = employees.map((emp: any) => ({
    value: emp.EmployeeID,
    label: emp.Name,
  }));

  useEffect(() => {
    dispatch(getEmployees());
    setterminationtype(Enum.TerminationType);
    dispatch(fetchAllTermination());
  }, []);

  const data = termination ? termination : [];

  const filteredData = useMemo(() => {
    return filterData(data || [], {}, "CreatedAt", "CreatedAt", selectedSort);
  }, [dispatch, termination, selectedSort, selectedStatus]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, termination, selectedSort, selectedStatus]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "Resigning_Employee",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          {/* <Link to={all_routes.invoiceDetails} className="avatar avatar-md me-2">
            <ImageWithBasePath
              src={`assets/img/users/${record.Image}`}
              className="rounded-circle"
              alt="user"
            />
          </Link> */}
          <h6 className="fw-medium">
            <div>
              {/* {all_routes.invoiceDetails} */}
              {record.Resigning_Employee}
            </div>
          </h6>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.Resigning_Employee.length - b.Resigning_Employee.length,
    },
    // {
    //   title: "Department",
    //   dataIndex: "Department",
    //   sorter: (a: any, b: any) => a.Department.length - b.Department.length,
    // },
    {
      title: "Termination Type",
      dataIndex: "Termination_Type",
      sorter: (a: any, b: any) =>
        a.Termination_Type.length - b.Termination_Type.length,
    },
    {
      title: "Notice Date",
      dataIndex: "Notice_Date",
      render: (text: string) => {
        if (!text) return "-";
        const date = new Date(text);
        date.setDate(date.getDate());
        return formatDate(date, config);
      },
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.Notice_Date).getTime();
        const dateB = new Date(b.Notice_Date).getTime();
        return dateA - dateB;
      },
    },
    {
      title: "Reason",
      dataIndex: "Reason",
      sorter: (a: any, b: any) => a.Reason.length - b.Reason.length,
    },
    {
      title: "Termination Date",
      dataIndex: "Resignation_Date",
      render: (text: string) => {
        if (!text) return "-";
        const date = new Date(text);
        date.setDate(date.getDate());
        return formatDate(date, config);
      },
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.Resignation_Date).getTime();
        const dateB = new Date(b.Resignation_Date).getTime();
        return dateA - dateB;
      },
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          <Link to="#"
            data-bs-toggle="tooltip" data-bs-placement="top" title="Edit">

            <i
              className="ti ti-edit"
              onClick={() => {
                if (!canEdit) return;
                setIsEditing(true);
                handleEditPolicy(record);
                setIsDrawerVisible(true);
              }}
              style={{
                pointerEvents: canEdit ? "auto" : "none",
                cursor: canEdit ? "pointer" : "not-allowed",
                opacity: canEdit ? 1 : 0.5,
              }}
            />
          </Link>


          <Link to="#"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Delete">
            <i
              className="ti ti-trash"
              onClick={() => {
                if (!canDelete) return;
                setSelectedRowData(record);
                setIsDeleteModalVisible(true);
              }}
              style={{
                pointerEvents: canDelete ? "auto" : "none",
                cursor: canDelete ? "pointer" : "not-allowed",
                opacity: canDelete ? 1 : 0.5,
              }}
            />
          </Link>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Termination</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Termination
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canAdd && (
                <div className="mb-2">
                  <Button
                    type="primary"
                    className="btn btn-primary d-flex align-items-center"
                    onClick={() => {
                      setFormData({
                        employee: "",
                        terminationType: "",
                        noticeDate: "",
                        reason: "",
                        resignationDate: "",
                        createdBy: user.UserId,
                      });
                      setIsDrawerVisible(true);
                      setIsEditing(false);
                    }}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Termination
                  </Button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Termination List */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5 className="d-flex align-items-center">
                    Termination List
                  </h5>
                  <div className="d-flex align-items-center flex-wrap row-gap-3">
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedSort
                          ? `Sort By : ${selectedSort}`
                          : "Sort By : Last 7 Days"}
                      </Link>
                      <ul className="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Recently Added")}
                            className="dropdown-item rounded-1"
                          >
                            Recently Added
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Ascending")}
                            className="dropdown-item rounded-1"
                          >
                            Ascending
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Descending")}
                            className="dropdown-item rounded-1"
                          >
                            Descending
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Last Month")}
                            className="dropdown-item rounded-1"
                          >
                            Last Month
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Last 7 Days")}
                            className="dropdown-item rounded-1"
                          >
                            Last 7 Days
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0">
                  <Table
                    key={tableKey}
                    dataSource={filteredData}
                    columns={columns}
                    Selection={true}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Termination List  */}
        </div>
        {/* Footer */}
        <div className="footer d-sm-flex align-items-center justify-content-between bg-white border-top p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      <>
        <Drawer
          title={isEditing ? "Update Termination" : "Add Termination"}
          placement="right"
          width={500}
          onClose={() => setIsDrawerVisible(false)}
          open={isDrawerVisible}
          style={{ marginTop: 50, paddingBottom: 50 }}
        >
          <form onSubmit={handleSubmit}>
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Employee <span className="text-danger"> *</span>
                    </label>
                    <Select
                      className="select"
                      options={formattedEmployees.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                      value={
                        formattedEmployees.find(
                          (emp: any) => emp.value === formData.employee
                        ) || null
                      }
                      onChange={(selectedOption: any) =>
                        handleSelectChange(selectedOption, "employee")
                      }
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Termination Type <span className="text-danger"> *</span>
                    </label>
                    <Select
                      className="select"
                      options={formattedTerminationTypes.sort((a: any, b: any) => a.label.localeCompare(b.label))}
                      value={
                        formattedTerminationTypes.find(
                          (type) => type.value === formData.terminationType
                        ) || null
                      }
                      onChange={(selectedOption: any) =>
                        handleSelectChange(selectedOption, "terminationType")
                      }
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Notice Date <span className="text-danger"> *</span>
                    </label>
                    <div className="input-icon-end position-relative">
                      <DatePicker
                        className="form-control datetimepicker"
                        selected={formData.noticeDate}
                        onChange={(date) =>
                          handleDateChange(date, "noticeDate")
                        }
                        dateFormat="dd-MM-yyyy"
                        placeholderText="DD-MM-YYYY"
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-7" />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Reason <span className="text-danger"> *</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows={3}
                      value={formData.reason}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">Termination Date  <span className="text-danger"> *</span></label>
                    <div className="input-icon-end position-relative">
                      <DatePicker
                        className="form-control datetimepicker"
                        selected={formData.resignationDate}
                        onChange={(date) =>
                          handleDateChange(date, "resignationDate")
                        }
                        dateFormat="dd-MM-yyyy"
                        placeholderText="DD-MM-YYYY"
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-7" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-white border me-2"
                onClick={() => setIsDrawerVisible(false)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary"
                disabled={isLoading}>
                {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
                {isEditing ? "Update Termination" : "Add Termination"}
              </button>
            </div>
          </form>
        </Drawer>

        {/* /Edi Termination */}
        {/* Delete Modal */}
        <DeleteModal1
          isVisible={isDeleteModalVisible}
          onClose={() => setIsDeleteModalVisible(false)}
          onConfirm={() =>
            selectedRowData?.ID && handleDeletePolicy(selectedRowData.ID)
          }
        />
        {/* /Delete Modal */}
      </>
    </>
  );
};

export default Termination;
